import { Map, OrderedMap, fromJS } from 'immutable';
import isEmpty from 'lodash/isEmpty';

import ReviewsConstants from 'Shared/constants/Reviews.constants';
import ReviewFormsConstants from 'Shared/constants/ReviewForms.constants';
import ReviewCyclesConstants from 'Shared/constants/ReviewCycles.constants';

const initialState = Map({
  [ReviewsConstants.State.REVIEWS_BY_REVIEW_SLUG]: OrderedMap(),
  [ReviewsConstants.State.REVIEW_FORMS_BY_REVIEW_FORM_SLUG]: OrderedMap(),
});

export const ReviewsReducer = (state = initialState, action) => {
  switch (action.type) {
    case ReviewFormsConstants.Actions.CREATE_REVIEW_FORMS_SUCCESS:
    case ReviewFormsConstants.Actions.FETCH_REVIEW_FORMS_SUCCESS:
    case ReviewFormsConstants.Actions.SUBMIT_REVIEW_FORM_SUCCESS:
    case ReviewFormsConstants.Actions.UNSUBMIT_REVIEW_FORM_SUCCESS:
    case ReviewFormsConstants.Actions.REOPEN_REVIEW_FORM_SUCCESS:
    case ReviewFormsConstants.Actions.UPDATE_REVIEW_FORM_COMPILER_SUCCESS:
    case ReviewsConstants.Actions.FETCH_SINGLE_REVIEW_SUCCESS:
    case ReviewsConstants.Actions.FETCH_REVIEWS_SUCCESS:
    case ReviewsConstants.Actions.CREATE_REVIEW_SUCCESS:
    case ReviewsConstants.Actions.UPDATE_REVIEW_SUCCESS:
    case ReviewsConstants.Actions.UPDATE_REVIEW_COMPILER_SUCCESS:
    case ReviewsConstants.Actions.RECEIVER_VIEWED_REVIEW_SUCCESS:
    case ReviewCyclesConstants.Actions.FETCH_REVIEW_CYCLE_SUCCESS:
    case ReviewCyclesConstants.Actions.LAUNCH_REVIEW_CYCLE_SUCCESS:
    case ReviewCyclesConstants.Actions.CREATE_REVIEWS_ON_REVIEW_CYCLE_SUCCESS:
      // is there is no data, json-api-normalizr will convert payload to
      // an empty object, we need to ensure it's not empty before trying to iterate over items
      if (isEmpty(action.payload)) {
        return state;
      }
      return state
        .updateIn([ReviewsConstants.State.REVIEWS_BY_REVIEW_SLUG], (existing = OrderedMap()) =>
          existing.merge(
            Object.values(action.payload.review).map(item => [item.attributes.slug, Map(fromJS(item.attributes))])
          )
        )
        .updateIn([ReviewsConstants.State.REVIEW_FORMS_BY_REVIEW_FORM_SLUG], (existing = OrderedMap()) =>
          existing.merge(
            Object.values(action.payload.reviewForm).map(item => [item.attributes.slug, Map(fromJS(item.attributes))])
          )
        );
    case ReviewFormsConstants.Actions.DELETE_REVIEW_FORMS_SUCCESS:
      return state.deleteIn([ReviewsConstants.State.REVIEW_FORMS_BY_REVIEW_FORM_SLUG, action.payload]);
    case ReviewCyclesConstants.Actions.DELETE_REVIEW_SUCCESS:
      return state
        .deleteIn([ReviewsConstants.State.REVIEWS_BY_REVIEW_SLUG, action.payload.reviewSlug])
        .updateIn([ReviewsConstants.State.REVIEW_FORMS_BY_REVIEW_FORM_SLUG], (reviewForms = OrderedMap()) =>
          reviewForms.filter(reviewForm => reviewForm.get('reviewSlug') !== action.payload.reviewSlug)
        );
    default:
      return state;
  }
};
